var render, staticRenderFns
import script from "./ThgImpactSelectorWithCustomerAccount.vue?vue&type=script&lang=ts"
export * from "./ThgImpactSelectorWithCustomerAccount.vue?vue&type=script&lang=ts"
import style0 from "./ThgImpactSelectorWithCustomerAccount.vue?vue&type=style&index=0&id=a1dbb58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dbb58e",
  null
  
)

export default component.exports